import {SEND_API_MESSAGE_START, SEND_API_MESSAGE} from "./WidgetActions";

const INITIAL_STATE = {
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SEND_API_MESSAGE_START:
            return {...state, apiFetching: true};
        case SEND_API_MESSAGE:
            if (action.error) {
                return {...state, error: action.payload.message, apiFetching: false};
            }
            return {...state, ...action.payload.data, fetching: false};
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/widget/WidgetReducer.js